import type { ReactNode } from 'react';
import { isInstalledTablet } from './isPwaMode';
import { PwaPushGate } from './PwaPushGate';
import { usePushHeartbeat } from './usePushHeartbeat';

/** Bloqueo + aviso de "app abierta", solo para la tablet con la app instalada. */
function Gated({ children }: { children: ReactNode }) {
  usePushHeartbeat();
  return <PwaPushGate>{children}</PwaPushGate>;
}

/**
 * Tablet con la app instalada: usa la plataforma web COMPLETA (con las sesiones y las videollamadas), pero con el mismo bloqueo por
 * notificaciones que el celular (`PwaPushGate`): hasta que estén activadas solo se ve la pantalla de activación. En cualquier otro
 * caso (navegador, desktop, celular —que tiene su propia app—) no hace nada. Es un bloqueo de UX, no de seguridad; falla abierto
 * (sin red, sin soporte, sesión impersonada…): ver `pushGate.ts`.
 */
export function InstalledTabletPushGate({ children }: { children: ReactNode }) {
  if (!isInstalledTablet()) return <>{children}</>;
  return <Gated>{children}</Gated>;
}
